import { z } from 'zod';
import { Cuid2, Email, PersonName } from './primitives.js';
/** Every admin action on a user carries a reason, kept in AuditLog. */
export const AdminReason = z
    .string()
    .trim()
    .min(1, 'Give a reason.')
    .max(500, 'Keep the reason under 500 characters.');
/** `POST /admin/users/:id/ban`, `/unban` and `/revoke-sessions`. */
export const AdminUserActionInput = z.object({ reason: AdminReason });
/** `POST /admin/admins/invite`. The invitee sets their own password from the email. */
export const InviteAdminInput = z.object({
    email: Email,
    name: PersonName,
    reason: AdminReason,
});
export const InviteAdminResult = z.object({ userId: Cuid2 });
//# sourceMappingURL=admin.js.map